module.exports = __webpack_public_path__ + "img/newImg11.5b14cb6a.png";